import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const runRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/runs/:agentRunId',
});

export const prGroupRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/pull-requests/:groupId',
});
